// Browsers other than Safari can't display HEIC, so convert to JPG before upload.
// Non-HEIC files are returned unchanged.
export default async function convertHeicToJpg(file) {
  const isHeic =
    /image\/hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name);
  if (!isHeic) return file;

  const { default: heic2any } = await import("heic2any");
  const result = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 });
  // ponytail: multi-image HEIC (bursts) keeps only the first frame
  const blob = Array.isArray(result) ? result[0] : result;
  const name = file.name.replace(/\.hei[cf]$/i, "") + ".jpg";
  return new File([blob], name, { type: "image/jpeg" });
}
